var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#171717"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(451 51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -37.4L32.4 -18.7L32.4 18.7L0 37.4L-32.4 18.7L-32.4 -18.7Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(626 518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -13L11.3 -6.5L11.3 6.5L0 13L-11.3 6.5L-11.3 -6.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(239 449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -30L26 -15L26 15L0 30L-26 15L-26 -15Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(667 244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -23L19.9 -11.5L19.9 11.5L0 23L-19.9 11.5L-19.9 -11.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(741 484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -25L21.7 -12.5L21.7 12.5L0 25L-21.7 12.5L-21.7 -12.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(425 330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -21L18.2 -10.5L18.2 10.5L0 21L-18.2 10.5L-18.2 -10.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201 537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -22L19.1 -11L19.1 11L0 22L-19.1 11L-19.1 -11Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(856 286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -30L26 -15L26 15L0 30L-26 15L-26 -15Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -20L17.3 -10L17.3 10L0 20L-17.3 10L-17.3 -10Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(657 378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -24L20.8 -12L20.8 12L0 24L-20.8 12L-20.8 -12Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -19L16.5 -9.5L16.5 9.5L0 19L-16.5 9.5L-16.5 -9.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(818 93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -34L29.4 -17L29.4 17L0 34L-29.4 17L-29.4 -17Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -36L31.2 -18L31.2 18L0 36L-31.2 18L-31.2 -18Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(484 190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -14L12.1 -7L12.1 7L0 14L-12.1 7L-12.1 -7Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544 276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -28L24.2 -14L24.2 14L0 28L-24.2 14L-24.2 -14Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(338 280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -33L28.6 -16.5L28.6 16.5L0 33L-28.6 16.5L-28.6 -16.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -28L24.2 -14L24.2 14L0 28L-24.2 14L-24.2 -14Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84 575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -5L4.3 -2.5L4.3 2.5L0 5L-4.3 2.5L-4.3 -2.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(886 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -15L13 -7.5L13 7.5L0 15L-13 7.5L-13 -7.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(765 168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -26L22.5 -13L22.5 13L0 26L-22.5 13L-22.5 -13Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383 455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -29L25.1 -14.5L25.1 14.5L0 29L-25.1 14.5L-25.1 -14.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(748 382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -4L3.5 -2L3.5 2L0 4L-3.5 2L-3.5 -2Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124 275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -12L10.4 -6L10.4 6L0 12L-10.4 6L-10.4 -6Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(898 94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -9L7.8 -4.5L7.8 4.5L0 9L-7.8 4.5L-7.8 -4.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213 342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -25L21.7 -12.5L21.7 12.5L0 25L-21.7 12.5L-21.7 -12.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(585 348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -23L19.9 -11.5L19.9 11.5L0 23L-19.9 11.5L-19.9 -11.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(798 583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -20L17.3 -10L17.3 10L0 20L-17.3 10L-17.3 -10Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -35L30.3 -17.5L30.3 17.5L0 35L-30.3 17.5L-30.3 -17.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(647 158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -31L26.8 -15.5L26.8 15.5L0 31L-26.8 15.5L-26.8 -15.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -12L10.4 -6L10.4 6L0 12L-10.4 6L-10.4 -6Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(524 438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -13L11.3 -6.5L11.3 6.5L0 13L-11.3 6.5L-11.3 -6.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -26L22.5 -13L22.5 13L0 26L-22.5 13L-22.5 -13Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528 113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -17L14.7 -8.5L14.7 8.5L0 17L-14.7 8.5L-14.7 -8.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138 422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -22L19.1 -11L19.1 11L0 22L-19.1 11L-19.1 -11Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(298 553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -36L31.2 -18L31.2 18L0 36L-31.2 18L-31.2 -18Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(497 554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -18L15.6 -9L15.6 9L0 18L-15.6 9L-15.6 -9Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(882 212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -19L16.5 -9.5L16.5 9.5L0 19L-16.5 9.5L-16.5 -9.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(386 540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -21L18.2 -10.5L18.2 10.5L0 21L-18.2 10.5L-18.2 -10.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(742 70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -14L12.1 -7L12.1 7L0 14L-12.1 7L-12.1 -7Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(898 412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -7L6.1 -3.5L6.1 3.5L0 7L-6.1 3.5L-6.1 -3.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(569 587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -18L15.6 -9L15.6 9L0 18L-15.6 9L-15.6 -9Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -31L26.8 -15.5L26.8 15.5L0 31L-26.8 15.5L-26.8 -15.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314 407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -16L13.9 -8L13.9 8L0 16L-13.9 8L-13.9 -8Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384 163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -19L16.5 -9.5L16.5 9.5L0 19L-16.5 9.5L-16.5 -9.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113 199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -31L26.8 -15.5L26.8 15.5L0 31L-26.8 15.5L-26.8 -15.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -29L25.1 -14.5L25.1 14.5L0 29L-25.1 14.5L-25.1 -14.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(499 361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -31L26.8 -15.5L26.8 15.5L0 31L-26.8 15.5L-26.8 -15.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(830 456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -14L12.1 -7L12.1 7L0 14L-12.1 7L-12.1 -7Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(646 597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -19L16.5 -9.5L16.5 9.5L0 19L-16.5 9.5L-16.5 -9.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(795 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -35L30.3 -17.5L30.3 17.5L0 35L-30.3 17.5L-30.3 -17.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -18L15.6 -9L15.6 9L0 18L-15.6 9L-15.6 -9Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -14L12.1 -7L12.1 7L0 14L-12.1 7L-12.1 -7Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(739 278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -12L10.4 -6L10.4 6L0 12L-10.4 6L-10.4 -6Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368 59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -9L7.8 -4.5L7.8 4.5L0 9L-7.8 4.5L-7.8 -4.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(883 582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -10L8.7 -5L8.7 5L0 10L-8.7 5L-8.7 -5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(195 211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -27L23.4 -13.5L23.4 13.5L0 27L-23.4 13.5L-23.4 -13.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(684 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -9L7.8 -4.5L7.8 4.5L0 9L-7.8 4.5L-7.8 -4.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720 582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -5L4.3 -2.5L4.3 2.5L0 5L-4.3 2.5L-4.3 -2.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(446 414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -7L6.1 -3.5L6.1 3.5L0 7L-6.1 3.5L-6.1 -3.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(524 33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -27L23.4 -13.5L23.4 13.5L0 27L-23.4 13.5L-23.4 -13.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(578 198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -35L30.3 -17.5L30.3 17.5L0 35L-30.3 17.5L-30.3 -17.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305 184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -15L13 -7.5L13 7.5L0 15L-13 7.5L-13 -7.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -12L10.4 -6L10.4 6L0 12L-10.4 6L-10.4 -6Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(173 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -10L8.7 -5L8.7 5L0 10L-8.7 5L-8.7 -5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251 272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -26L22.5 -13L22.5 13L0 26L-22.5 13L-22.5 -13Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(827 368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -33L28.6 -16.5L28.6 16.5L0 33L-28.6 16.5L-28.6 -16.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600 434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -9L7.8 -4.5L7.8 4.5L0 9L-7.8 4.5L-7.8 -4.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(894 504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -15L13 -7.5L13 7.5L0 15L-13 7.5L-13 -7.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -24L20.8 -12L20.8 12L0 24L-20.8 12L-20.8 -12Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426 246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -30L26 -15L26 15L0 30L-26 15L-26 -15Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(667 81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -15L13 -7.5L13 7.5L0 15L-13 7.5L-13 -7.5Z",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonBg2);
export default __webpack_public_path__ + "static/media/polygon_bg_2.b5bdc669ea385c712fd0e3e255d81ac4.svg";
export { ForwardRef as ReactComponent };